"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var NewConditionsAdapter_1 = require("./NewConditionsAdapter");
var NewPlacementAdapter = (function () {
    function NewPlacementAdapter(oldPlacement, media) {
        var _this = this;
        _.merge(this, oldPlacement);
        delete this["rawSample"];
        delete this["period"];
        this.medium = _.findIndex(media, (function (candidate) {
            return _.isEqual(candidate, oldPlacement.medium, function (compare) {
                return compare.key === oldPlacement.medium.key &&
                    compare.type === oldPlacement.medium.type
                    && compare.period === oldPlacement.medium.period;
            });
        }));
        this.setConditions(oldPlacement, media);
        var keys = Object.keys(this);
        keys.forEach(function (key) {
            var prop = _this[key];
            if (prop === undefined) {
                delete _this[key];
            }
        });
    }
    NewPlacementAdapter.prototype.setConditions = function (oldPlacement, media) {
        var tariffConditionId = this.getConditionId(media);
        this.conditions = new NewConditionsAdapter_1.NewConditionsAdapter(oldPlacement.conditions, tariffConditionId);
    };
    NewPlacementAdapter.prototype.getConditionId = function (media) {
        var theMedium = media[this.medium];
        return _.get(theMedium, "tariffConditionId");
    };
    return NewPlacementAdapter;
}());
exports.NewPlacementAdapter = NewPlacementAdapter;
//# sourceMappingURL=NewPlacementAdapter.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/adapters/NewPlacementAdapter.js
// module id = 38
// module chunks = 0